























































































































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CTextField from '@/components/base/textField/CTextField.vue';
import CTable from '@/components/base/table/CTable.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
@Component({
    components: {CNumberField, CSelect, CTable, CTextField, CCheckbox, CEditDialog},
})
export default class PlywoodProductionProcessEditDialog extends Mixins(EditDialogMixin) {
    errorKeyList = {
        Name: 'Name',
    };

    get productivityHeaders() {
        return [
            {
                value: 'IdPlywoodThickness',
                text: this.$t('Catalogues.Plywoods.PlywoodThickness.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodThickness),
                ),
            },
            {
                value: 'IdPlywoodSize',
                text: this.$t('Catalogues.Plywoods.PlywoodSize.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodSize),
                ),
            },
            {
                value: 'ProductivityVolume.Value',
                text: this.$t('Common.Productivity'),
            },
            {
                value: 'ProductivityVolume.IdMeasureUnit',
                text: this.$t('Common.ProductivityUnit'),
                sort: this.getDescriptionsContainer().getSortFn(this.addDescriptionPostfix(this.$api.measureUnit)),
            },
        ];
    }

    get forbiddenGradesHeaders() {
        return [
            {
                value: 'IdPlywoodGrade',
                text: this.$t('Catalogues.Plywoods.PlywoodGrade.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodGrade),
                ),
            },
        ];
    }

    get forbiddenSizesHeaders() {
        return [
            {
                value: 'IdPlywoodSize',
                text: this.$t('Catalogues.Plywoods.PlywoodSize.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodSize),
                ),
            },
        ];
    }
}
